import React from 'react';
import { TrialFilm } from './TrialFilm';
import { TrialTestimonials } from './TrialTestimonials';
import '../landing/arc/arc.css';
import './trial.css';
import './trial-focused.css';
import './trial-agency.css';

export const TrialShell = ({ children, planStep = false, ready = false, focused = false }) => (
  <main className={`trial-shell ${planStep ? 'trial-shell-plans' : ''} ${focused ? 'trial-shell-focused' : ''}`} data-layout={focused ? 'focused' : 'split'} data-testid="trial-shell">
    <section className="trial-left" data-testid="trial-form-pane">
      <div className="trial-form-wrap">
        <a href="/" className="trial-logo" data-testid="trial-home-link" aria-label="Voxinity AI home">
          <img src="/voxinity-logo.png" alt="Voxinity AI" data-testid="trial-brand-logo" />
        </a>
        {children}
        <footer className="trial-legal" data-testid="trial-legal-footer">
          <p>By continuing, you agree to our</p>
          <div><a href="https://voxinity.ai/terms" target="_blank" rel="noopener noreferrer" data-testid="terms-link">Terms of Use</a><span aria-hidden="true">|</span><a href="https://voxinity.ai/privacy" target="_blank" rel="noopener noreferrer" data-testid="privacy-link">Privacy Policy</a></div>
        </footer>
      </div>
    </section>
    {!focused && <aside className="trial-right" data-testid="trial-media-pane">
      <div className="trial-media-content">
        <p className="trial-eyebrow" data-testid="trial-media-eyebrow">BUILT FOR AGENCIES</p>
        <h2 className="trial-media-title" data-testid="trial-media-title">Your agency’s next service<br /><em>starts here.</em></h2>
        <p className="trial-media-subtitle" data-testid="trial-media-subtitle">Deliver AI voice, chat, and appointment booking to your clients.</p>
        <TrialFilm />
        <TrialTestimonials />
        {ready && <p className="trial-media-note" data-testid="trial-ready-note">Your workspace is ready. Make it yours.</p>}
      </div>
    </aside>}
  </main>
);

export const TrialAlert = ({ children, info = false }) => children ? <div role={info ? 'status' : 'alert'} className={`trial-alert ${info ? 'trial-alert-info' : ''}`} data-testid={info ? 'trial-info-message' : 'signup-error'}>{children}</div> : null;

export const TrialField = ({ label, id, ...props }) => <div className="trial-field"><label htmlFor={id}>{label}</label><input id={id} data-testid={id} {...props} /></div>;